export const formatApiErrorDetail = (detail) => {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
};

export const productOptions = {
  'Business Cards': {
    fields: [
      { name: 'size', label: 'Size', type: 'select', options: ['85x55mm (Standard)', '90x50mm', 'Custom'] },
      { name: 'sides', label: 'Sides', type: 'select', options: ['Single', 'Double'] },
      { name: 'orientation', label: 'Orientation', type: 'select', options: ['Horizontal', 'Vertical'] },
      { name: 'paper', label: 'Paper Type', type: 'select', options: ['Matte', 'Glossy', 'Textured', 'Premium'] },
      { name: 'thickness', label: 'Thickness', type: 'select', options: ['300gsm', '350gsm', '400gsm'] },
      { name: 'lamination', label: 'Lamination', type: 'select', options: ['None', 'Matte', 'Glossy', 'Soft Touch'] },
      { name: 'corners', label: 'Corners', type: 'select', options: ['Square', 'Rounded'] },
    ],
  },
  'Flyers': {
    fields: [
      { name: 'size', label: 'Size', type: 'select', options: ['A5', 'A4', 'A6', 'DL', 'Custom'] },
      { name: 'sides', label: 'Sides', type: 'select', options: ['Single', 'Double'] },
      { name: 'paper', label: 'Paper Type', type: 'select', options: ['130gsm Gloss', '170gsm Silk', '250gsm Gloss', '300gsm Silk'] },
    ],
  },
  'Brochures': {
    fields: [
      { name: 'foldType', label: 'Fold Type', type: 'select', options: ['Bi-fold', 'Tri-fold', 'Z-fold', 'Gate-fold'] },
      { name: 'size', label: 'Size', type: 'select', options: ['A4', 'A5', 'DL', 'Custom'] },
      { name: 'paper', label: 'Paper Type', type: 'select', options: ['130gsm Gloss', '170gsm Silk', '250gsm Gloss', '300gsm Silk'] },
    ],
  },
  'Bookmarks': {
    fields: [
      { name: 'size', label: 'Size', type: 'select', options: ['50x150mm', '55x210mm', 'Custom'] },
      { name: 'sides', label: 'Sides', type: 'select', options: ['Single', 'Double'] },
      { name: 'lamination', label: 'Lamination', type: 'select', options: ['None', 'Matte', 'Glossy'] },
      { name: 'holePunch', label: 'Hole Punching', type: 'select', options: ['Yes', 'No'] },
    ],
  },
  'Envelopes': {
    fields: [
      { name: 'size', label: 'Size', type: 'select', options: ['DL', 'C5', 'C4', 'Custom'] },
      { name: 'color', label: 'Color', type: 'select', options: ['White', 'Cream', 'Custom Print'] },
      { name: 'window', label: 'Window', type: 'select', options: ['No Window', 'With Window'] },
    ],
  },
  'Invitations (Wedding / Party)': {
    fields: [
      { name: 'category', label: 'Category', type: 'select', options: ['Wedding', 'Party', 'Corporate Event'] },
      { name: 'size', label: 'Size', type: 'select', options: ['A6', 'Square 150x150mm', 'DL', 'Custom'] },
      { name: 'paper', label: 'Paper Type', type: 'select', options: ['Premium Textured', 'Pearl', 'Linen', 'Glossy'] },
    ],
  },
  'Document Printing': {
    fields: [
      { name: 'color', label: 'Color', type: 'select', options: ['Black & White', 'Full Color'] },
      { name: 'pages', label: 'Number of Pages', type: 'number' },
      { name: 'binding', label: 'Binding', type: 'select', options: ['None', 'Stapled', 'Spiral Bound', 'Perfect Bound'] },
    ],
  },
  'Notepads (Business)': {
    fields: [
      { name: 'size', label: 'Size', type: 'select', options: ['A4', 'A5', 'A6', 'Custom'] },
      { name: 'sheets', label: 'Sheets per Pad', type: 'select', options: ['50', '100', '150'] },
      { name: 'color', label: 'Color Printing', type: 'select', options: ['Full Color Header', 'Black & White', 'Full Color'] },
    ],
  },
  'Pads (General small print)': {
    fields: [
      { name: 'size', label: 'Size', type: 'select', options: ['A6', 'A7', 'Custom'] },
      { name: 'sheets', label: 'Sheets per Pad', type: 'select', options: ['50', '100'] },
      { name: 'color', label: 'Color', type: 'select', options: ['Black & White', 'Full Color'] },
    ],
  },
  'Custom Request': {
    fields: [
      { name: 'projectType', label: 'Project Type', type: 'text', placeholder: 'e.g., Large format banners, special materials' },
      { name: 'description', label: 'Detailed Description', type: 'textarea', placeholder: 'Please describe your custom printing requirements in detail...' },
    ],
  },
};
